
        import { createElement } from 'react';
        import { render } from 'react-dom';
        import 'wix/scripts/dashboard-asset/111d1d55-1d1c-46a5-a851-07d0c94f839e.js';

        async function main() {
          const getComponent = await window['__module_federation__containers']['bd59b79d-a12b-406d-914a-b85843e83362'].get('111d1d55-1d1c-46a5-a851-07d0c94f839e');
          render(createElement(getComponent().default), document.getElementById('root'));
        }

        main();
      